'use strict';

var React = require('react');
var Teaser = require('./Teaser');

class TeaserItems extends React.Component {
	render() {
		var item = this.props.model;
		if (!item) {
			return false;
		}
		return (
			<Teaser model={item} teaserArea="minor" />
		);
	}
}
TeaserItems.displayItem = 'TeaserItems';


class MinorTeaserArea extends React.Component {

	render() {
		if (!this.props.model || this.props.model.isEmpty()) {
			return false;
		}
		var model = this.props.model.toJS();

		var itemsFirst = model.slice(0, 2);
		var itemsSecond = model.slice(2, 4);
		var itemsThird = model.slice(4, 6);
		var itemsForth = model.slice(6, 8);

		return (
			<div className="svtse_minor-teaser-area">
				<div className="svtse_grid">

					{/* First 4 items */}
					<div className="svtse_minor-teaser-area__holder--first svtse_grid__col-full-halves--small">
						<div className="svtse_grid">
							<div className="svtse_grid__col-full-halves--large">
								{itemsFirst.map(function (itemsFirst, index) {
									return (
										<TeaserItems model={itemsFirst} key={index}/>
									);
								})}
							</div>

							<div className="svtse_grid__col-full-halves--large">
								{itemsSecond.map(function (itemsSecond, index) {
									return (
										<TeaserItems model={itemsSecond} key={index}/>
									);
								})}
							</div>
						</div>
					</div>

					{/* Last 4 items */}
					<div className="svtse_minor-teaser-area__holder--last svtse_grid__col-full-halves--small">
						<div className="svtse_grid">
							<div className="svtse_grid__col-full-halves--large">
								{itemsThird.map(function (itemsThird, index) {
									return (
										<TeaserItems model={itemsThird} key={index}/>
									);
								})}
							</div>

							<div className="svtse_grid__col-full-halves--large">
								{itemsForth.map(function (itemsForth, index) {
									return (
										<TeaserItems model={itemsForth} key={index}/>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
MinorTeaserArea.displayName = 'MinorTeaserArea';
MinorTeaserArea.propTypes = {
	model: React.PropTypes.object.isRequired
};

module.exports = MinorTeaserArea;



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/MinorTeaserArea.jsx
 **/